// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"431":"e72c4787","580":"68cac9cd"}[chunkId] + ".chunk.css";
};